import { FC } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Typography } from '@mui/material';

interface FormViewHeaderProps {
  title: string | React.ReactNode;
  onBack: () => void;
}

/**
 * Shared page-level header used by all inline form views (Add Company, Add User, etc.).
 * Renders a back-arrow button and a title
 */
const FormViewHeader: FC<FormViewHeaderProps> = ({ title, onBack }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', mb: '2rem' }}>
    <IconButton onClick={onBack} size="small" disableRipple sx={{ color: '#1B1C17' }}>
      <ArrowBackIcon />
    </IconButton>
    {typeof title === 'string' ? (
      <Typography
        fontSize="22px"
        fontWeight="600"
        lineHeight="1.5rem"
        fontFamily="Manrope, sans-serif"
        sx={{ color: '#1B1C17' }}
      >
        {title}
      </Typography>
    ) : (
      title
    )}
  </Box>
);

export default FormViewHeader;
